import {
    ADDNEWBANKINPARTNER_SUCCESS,
    ADDNEWBANKINPARTNER_FAILED,
    RESET_ADDNEWBANKINPARTNER,
    LOADING_ADDNEWBANKINPARTNER,
    NETWORK_ERROR_ADDNEWBANKINPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDNEWBANKINPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case ADDNEWBANKINPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case ADDNEWBANKINPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_ADDNEWBANKINPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_ADDNEWBANKINPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};